import React from 'react';
import PropTypes from 'prop-types';
import {
	makeStyles,
	//Paper,
	Typography
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	root: {
		backgroundColor: "transparent"
	},

	/*mobile: {
		padding: theme.spacing(1.5),
		paddingLeft: theme.spacing(2),
		backgroundColor: theme.palette.primary.tan
	},*/

	typography: {
		fontWeight: 350,
		textAlign: "center"
	},

	smallerFont: {
		fontSize: "0.9rem"
	}
}));

function AccountInfoBar(props) {
	let classes = styles(),
		{user, showId, /*isMobile,*/ className} = props;

	return (
		<Typography variant="caption" className={`${classes.typography} ${className}`}>
			{user.accountName}{showId ? ` (ID: ${user.accountId})` : null}
		</Typography>
		/*<Paper className={`${classes.root} ${!isMobile ? classes.mobile : ""}`} elevation={0} square>
			<Typography className={`${classes.typography} ${!isMobile ? classes.smallerFont : ""}`}>
				{user.accountName}{showId ? ` (ID: ${user.accountId})` : null}
			</Typography>
		</Paper>*/
	);
}

AccountInfoBar.propTypes = {
	showId: PropTypes.bool,
	//isMobile: PropTypes.bool,
	className: PropTypes.string,
	user: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]).isRequired
};

export default AccountInfoBar;
